export default "__VITE_ASSET__17de67d7__"